import type { ProductNoEdibleInfo } from "@dransay/api";
import type { TFunction } from "i18next";

export function getProductDescription(
	product: ProductNoEdibleInfo,
	t: TFunction,
) {
	if (product.description && product.description.length > 0) {
		return product.description;
	}
	const name = product.name;
	const kind = product.kind;
	const genetics = product.genetics
		? product.genetics.charAt(0).toUpperCase() + product.genetics.slice(1)
		: null;
	const thc = product.thc;
	const cbd = product.cbd;
	const terpenes =
		product.terpenes && product.terpenes.length > 0
			? (product.terpenes.map((terpen) => terpen.name).join(", ") as string)
			: null;
	if (!genetics) {
		return product.description ?? "";
	}
	if (product.category === "flowers") {
		return `${t("flowerDescription", { name, kind, genetics, thc, cbd, interpolation: { escapeValue: false } })}\n${terpenes ? t("terpenesDescription", { terpenes, count: product.terpenes?.length }) : ""}`;
	}
	if (product.category === "extracts") {
		return `${t("extractDescription", { name, kind, genetics, thc, cbd, interpolation: { escapeValue: false } })}\n${terpenes ? t("terpenesDescription", { terpenes, count: product.terpenes?.length }) : ""}`;
	}
	return "";
}
